module.exports = __webpack_public_path__ + "img/Image6@2x.015aba2e.jpg";